import type { MachineDetail } from "../../../domain/types/machine-detail";
import { MachineDetailSchema } from "../../../domain/types/machine-detail";
import type {
  MachineEntity,
  RouterMachinesResponse,
} from "../../../domain/types/machine";
import { RouterMachinesResponseSchema } from "../../../domain/types/machine";
import type { CompanyMachineRepository } from "../../../domain/repositories/company/company-machine-repository";
import { companyMachineApiService } from "../../api/company/company-machine-api-service";

export class CompanyMachineRepositoryImpl implements CompanyMachineRepository {
  async getMachineDetails(companyId: number): Promise<MachineDetail[]> {
    const response =
      await companyMachineApiService.getMachineDetails(companyId);

    if (response.data) {
      return response.data.map((machine) => MachineDetailSchema.parse(machine));
    }

    throw new Error(response.errorMsg || "장비 정보 가져오기 실패.");
  }

  async getMachineDetailsByRouter(
    companyId: number,
  ): Promise<RouterMachinesResponse[]> {
    const response =
      await companyMachineApiService.getMachineDetailsByRouter(companyId);

    if (response.data) {
      return response.data.map(item => RouterMachinesResponseSchema.parse(item));
    }

    throw new Error(response.errorMsg || "장비 정보 가져오기 실패.");
  }
}
